import KendoSpreadsheet from '../KendoSpreadsheet'
import KendoSpreadsheetSheet from '../KendoSpreadsheetSheet'

let KendoSpreadsheetInstaller = class {
    static install(Vue) {
        Vue.component(KendoSpreadsheet.name, KendoSpreadsheet)
        Vue.component(KendoSpreadsheetSheet.name, KendoSpreadsheetSheet)
    }
}

export default KendoSpreadsheetInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoSpreadsheetInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/kendo-spreadsheet-installer/index.js